import './WizardInfoMessage.css';
import React from 'react';
import { ReactComponent as InfoIcon } from '../../../resources/icons/info-tooltip-uncolor.svg';
export var WizardInfoMessage = function WizardInfoMessage(_ref) {
  var infoMessage = _ref.infoMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard-info-message"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: "wizard-info-message__info-icon",
    "aria-hidden": true
  }), infoMessage));
};
var commonStyles = "cvd17z2";